import { toast } from 'react-toastify';
import { Flip } from 'react-toastify';

export const showToast = (type, message) => {
    const options = {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        transition: Flip
    };

    switch (type) {
        case 'success':
            toast.success(message, options);
            break;
        case 'error':
            toast.error(message, options);
            break;
        case 'info':
            toast.info(message, options);
            break;
        default:
            console.error('Invalid toast type:', type);
    }
};